module.exports = __webpack_public_path__ + "62bc47cd3c7a0083263af8ff58f58eb2.svg";